export class SessionPromptDefinitionError extends Error {}
export function applySessionDialogueDefinition<T extends object>(details:T,version?:number|null):T & {dialogue_definition_version?:number}{
  if(version==null)return details;
  if(version!==1)throw new SessionPromptDefinitionError('Session dialogue definition is unsupported.');
  return {...details,dialogue_definition_version:version};
}

export function applySessionResponseDefinition<T extends object>(details:T,version?:number|null):T & {response_definition_version?:number}{
  if(version==null)return details;
  if(version!==1)throw new SessionPromptDefinitionError('Session response guidance is unsupported.');
  return {...details,response_definition_version:version};
}
